// import ChartBarIcon from '@heroicons/react/24/solid/ChartBarIcon';
import CogIcon from '@heroicons/react/24/solid/CogIcon';
import UsersIcon from '@heroicons/react/24/solid/UsersIcon';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import ChartBarIcon from '@mui/icons-material/';
import PeopleIcon from '@mui/icons-material/People';
import StoreIcon from '@mui/icons-material/Store';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { SvgIcon } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PaidIcon from '@mui/icons-material/Paid';
import HistoryIcon from '@mui/icons-material/History';

export interface MenuItem {
	title: string;
	path: string;
	icon: React.ReactNode;
	roles?: string[]; // If specified, only these roles can see this item
	/**
	 * The business-profile trait this entry needs (location-business-profile
	 * D11): 'services' is shown only where services are on and titled by the
	 * services label; 'staff' only where staff is not Off and titled
	 * "{staff label} Commission". The routes redirect too (Routes.tsx).
	 */
	requires?: 'services' | 'staff';
}

export interface MenuSection {
	sectionTitle: string;
	sectionIcon: React.ReactNode;
	items: MenuItem[];
	roles?: string[]; // If specified, only these roles can see this section
}

export const menuSections: MenuSection[] = [
	{
		sectionTitle: 'Dashboard',
		sectionIcon: (
			<SvgIcon fontSize="small">
				<DashboardIcon />
			</SvgIcon>
		),
		items: [
			{
				title: 'Report',
				path: '/dashboard/report',
				icon: (
					<SvgIcon fontSize="small">
						<QueryStatsIcon />
					</SvgIcon>
				)
			},
			{
				title: 'User Events',
				path: '/dashboard/user-events',
				icon: (
					<SvgIcon fontSize="small">
						<HistoryIcon />
					</SvgIcon>
				)
			}
		]
	},
	{
		sectionTitle: 'Sales & Operations',
		sectionIcon: (
			<SvgIcon fontSize="small">
				<BusinessIcon />
			</SvgIcon>
		),
		items: [
			{
				title: 'Orders',
				path: '/dashboard/orders',
				icon: (
					<SvgIcon fontSize="small">
						<ShoppingCartIcon />
					</SvgIcon>
				)
			},
			{
				title: 'Delivery Orders',
				path: '/dashboard/delivery-orders',
				icon: (
					<SvgIcon fontSize="small">
						<LocalShippingIcon />
					</SvgIcon>
				)
			},
			{
				title: 'Customers',
				path: '/dashboard/customers',
				icon: (
					<SvgIcon fontSize="small">
						<PeopleIcon />
					</SvgIcon>
				)
			}
		]
	},
	{
		sectionTitle: 'Catalog',
		sectionIcon: (
			<SvgIcon fontSize="small">
				<InventoryIcon />
			</SvgIcon>
		),
		items: [
			{
				title: 'Products',
				path: '/dashboard/products',
				icon: (
					<SvgIcon fontSize="small">
						<Inventory2Icon />
					</SvgIcon>
				)
			},
			{
				title: 'Categories',
				path: '/dashboard/product-categories',
				icon: (
					<SvgIcon fontSize="small">
						<InventoryIcon />
					</SvgIcon>
				)
			},
			{
				title: 'Services',
				path: '/dashboard/services',
				icon: (
					<SvgIcon fontSize="small">
						<MiscellaneousServicesIcon />
					</SvgIcon>
				),
				requires: 'services'
			}
		]
	},
	{
		sectionTitle: 'Finance',
		sectionIcon: (
			<SvgIcon fontSize="small">
				<AttachMoneyIcon />
			</SvgIcon>
		),
		items: [
			{
				title: 'Expense',
				path: '/dashboard/expenses',
				icon: (
					<SvgIcon fontSize="small">
						<CurrencyRupeeIcon />
					</SvgIcon>
				)
			},
			{
				title: 'Commission',
				path: '/dashboard/commission',
				icon: (
					<SvgIcon fontSize="small">
						<PaidIcon />
					</SvgIcon>
				),
				roles: ['SHOP_ADMIN', 'SUPER_ADMIN'],
				requires: 'staff'
			}
		]
	},
	{
		sectionTitle: 'Administration',
		sectionIcon: (
			<SvgIcon fontSize="small">
				<AdminPanelSettingsIcon />
			</SvgIcon>
		),
		items: [
			{
				title: 'Shops',
				path: '/dashboard/shops',
				icon: (
					<SvgIcon fontSize="small">
						<StoreIcon />
					</SvgIcon>
				),
				roles: ['SUPER_ADMIN'] // Only root admins can see this
			},
			{
				title: 'Locations',
				path: '/dashboard/locations',
				icon: (
					<SvgIcon fontSize="small">
						<LocationOnIcon />
					</SvgIcon>
				),
				roles: ['SUPER_ADMIN', 'SHOP_ADMIN'] // Root and shop admins
			},
			{
				title: 'Users',
				path: '/dashboard/users',
				icon: (
					<SvgIcon fontSize="small">
						<UsersIcon />
					</SvgIcon>
				)
			},
			{
				title: 'Settings',
				path: '/dashboard/settings',
				icon: (
					<SvgIcon fontSize="small">
						<CogIcon />
					</SvgIcon>
				)
			}
		]
	}
];
